import React from 'react';
import { useAuth, SignInButton } from '@clerk/clerk-react';
import { Button, ButtonProps } from '@/components/ui/button';

interface AuthButtonProps extends ButtonProps {
  onAuthenticatedClick?: () => void;
  requireAuth?: boolean;
  signInMode?: 'modal' | 'redirect';
}

/**
 * Button component that handles authentication state.
 * - When signed in: Executes onAuthenticatedClick
 * - When signed out: Opens Clerk sign-in modal
 */
export function AuthButton({
  onAuthenticatedClick,
  requireAuth = true,
  signInMode = 'modal',
  children,
  ...buttonProps
}: AuthButtonProps): React.ReactElement {
  const { isSignedIn } = useAuth();

  if (!requireAuth || isSignedIn) {
    return (
      <Button onClick={onAuthenticatedClick} {...buttonProps}>
        {children}
      </Button>
    );
  }

  return (
    <SignInButton mode={signInMode}>
      <Button {...buttonProps}>
        {children}
      </Button>
    </SignInButton>
  );
}